import request from '@/router/axios'
import env from '@/config/env'
import { pickBy } from 'lodash-es'
import qs from 'qs'
import globalVariable from '@/config/globalVariable'

const { TIME } = globalVariable

//获取供应商列表
export function queryMerchantList(params) {
  return request({
    url: env.ferryUrl + '/flightManage/queryMerchantList',
    method: 'get',
    timeout: TIME,
    params
  })
}

//获取老系统线路列表
export function lineList(params) {
  return request({
    url: env.ferryUrl + '/lineConfig/lineList',
    method: 'get',
    timeout: TIME,
    params
  })
}

//查询供应商相关的司机和车辆信息
export function driverAndCarInfo(params) {
  return request({
    url: env.ferryUrl + '/c-order/queryMerchantDriverAndCarInfo',
    method: 'post',
    timeout: TIME,
    data: params
  })
}

//老系统财务统计汇总
export function sum(params) {
  return request({
    url: env.ferryUrl + '/old-finance-statistic/sum',
    method: 'post',
    timeout: TIME,
    data: params
  })
}
//老系统财务统计分页
export function page(params) {
  return request({
    url: env.ferryUrl + '/old-finance-statistic/page',
    method: 'post',
    timeout: TIME,
    data: params
  })
}
//老系统财务统计导出
export function derive(params) {
  let url = env.importExcelUrl + env.ferryUrl + `/old-finance-statistic/export`
  let parma = pickBy({ ...params })
  url = url + '?' + qs.stringify(parma)
  return (window.location.href = url)
}
//老系统财务统计同步
export function sync(params) {
  return request({
    url: env.ferryUrl + '/old-finance-statistic/sync',
    method: 'post',
    timeout: TIME,
    data: params
  })
}
